// @ts-nocheck
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ISO8601Date: { input: string; output: string; }
  ISO8601DateTime: { input: string; output: string; }
  JSON: { input: any; output: any; }
};

/** Autogenerated input type of AddOrderItemMutation */
export type AddOrderItemMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['ID']['input'];
  modifierIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['Int']['input'];
  table?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AddOrderItemMutation. */
export type AddOrderItemMutationPayload = {
  __typename?: 'AddOrderItemMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  orderItem?: Maybe<OrderItem>;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Location>;
  restaurantId: Restaurant;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export type Algolia = {
  __typename?: 'Algolia';
  appId: Scalars['String']['output'];
  searchApiKey: Scalars['String']['output'];
  userIndexName: Scalars['String']['output'];
};

/** Autogenerated input type of ApplyLoyaltyRewardMutation */
export type ApplyLoyaltyRewardMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderItemId: Scalars['ID']['input'];
};

/** Autogenerated return type of ApplyLoyaltyRewardMutation. */
export type ApplyLoyaltyRewardMutationPayload = {
  __typename?: 'ApplyLoyaltyRewardMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  orderItem?: Maybe<OrderItem>;
};

export enum Auth {
  /** Apple OAuth */
  Apple = 'APPLE',
  /** Google OAuth */
  Google = 'GOOGLE',
  /** User has no authentication */
  None = 'NONE',
  /** User does not exist */
  NotFound = 'NOT_FOUND',
  /** Password */
  Password = 'PASSWORD',
  /** Phone */
  Phone = 'PHONE',
  /** Other */
  Unknown = 'UNKNOWN'
}

export type Bonus = {
  __typename?: 'Bonus';
  createdAt: Scalars['ISO8601DateTime']['output'];
  employeeAmount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  order: Order;
  restaurantAmount: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum CancelReason {
  /** Restaurant is closed */
  Closed = 'CLOSED',
  /** Item Unavailable */
  ItemsUnavailable = 'ITEMS_UNAVAILABLE',
  /** Rejected */
  Rejected = 'REJECTED',
  /** timed order */
  Timedout = 'TIMEDOUT'
}

export enum CancelableStatus {
  /** Can be canceled */
  Cancelable = 'CANCELABLE',
  /** Canceled */
  Canceled = 'CANCELED',
  /** Picked up */
  DeliveryPickedUp = 'DELIVERY_PICKED_UP',
  /** Cannot be canceled */
  Uncancelable = 'UNCANCELABLE'
}

/** Autogenerated input type of CreateAvatarUploadMutation */
export type CreateAvatarUploadMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  file: DirectUploadInputObject;
};

/** Autogenerated return type of CreateAvatarUploadMutation. */
export type CreateAvatarUploadMutationPayload = {
  __typename?: 'CreateAvatarUploadMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  directUpload: DirectUpload;
};

/** Autogenerated input type of CreateLoyaltyProgramMutation */
export type CreateLoyaltyProgramMutationInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  earningItemGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  earningThreshold?: InputMaybe<Scalars['Int']['input']>;
  earningType?: InputMaybe<Scalars['String']['input']>;
  enrollmentDescription?: InputMaybe<Scalars['String']['input']>;
  enrollmentHeading?: InputMaybe<Scalars['String']['input']>;
  enrollmentScreenPlacement?: InputMaybe<LoyaltyEnrollmentPlacement>;
  pointsPerDollar?: InputMaybe<Scalars['Int']['input']>;
  progressMessage?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['ID']['input'];
  rewardEarnedMessage?: InputMaybe<Scalars['String']['input']>;
  rewardIncludesModifiers?: InputMaybe<Scalars['Boolean']['input']>;
  rewardItemGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  smsProgressEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  starterPoints?: InputMaybe<Scalars['Int']['input']>;
  welcomeMessage?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateLoyaltyProgramMutation. */
export type CreateLoyaltyProgramMutationPayload = {
  __typename?: 'CreateLoyaltyProgramMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  loyaltyProgram?: Maybe<LoyaltyProgram>;
};

/** Autogenerated input type of CreateOrderMutation */
export type CreateOrderMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressAttributes?: InputMaybe<DeliveryAddressAttributes>;
  fulfillment?: InputMaybe<Fulfillment>;
  menuId?: InputMaybe<Scalars['ID']['input']>;
  orderItems: Array<OrderItemAttributes>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  restaurantId: Scalars['ID']['input'];
  scheduledAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  table?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateOrderMutation. */
export type CreateOrderMutationPayload = {
  __typename?: 'CreateOrderMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  order?: Maybe<Order>;
};

/** Autogenerated input type of CreatePaymentMutation */
export type CreatePaymentMutationInput = {
  amount: Scalars['Int']['input'];
  canMarket?: InputMaybe<Scalars['Boolean']['input']>;
  cashCollected?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  giftCardId?: InputMaybe<Scalars['ID']['input']>;
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['ID']['input']>;
  largePartyTip?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  payableUpdatedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  paymentIntentId?: InputMaybe<Scalars['ID']['input']>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  paymentType: OrderPayment;
  phone?: InputMaybe<Scalars['String']['input']>;
  serviceFee: Scalars['Int']['input'];
  status?: InputMaybe<OrderPaymentStatus>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreatePaymentMutation. */
export type CreatePaymentMutationPayload = {
  __typename?: 'CreatePaymentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  payment?: Maybe<Payment>;
};

/** Autogenerated input type of CreateSetupIntentMutation */
export type CreateSetupIntentMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateSetupIntentMutation. */
export type CreateSetupIntentMutationPayload = {
  __typename?: 'CreateSetupIntentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  clientSecret: Scalars['String']['output'];
};

/** Autogenerated input type of DeleteOrderItemMutation */
export type DeleteOrderItemMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteOrderItemMutation. */
export type DeleteOrderItemMutationPayload = {
  __typename?: 'DeleteOrderItemMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  orderItem?: Maybe<OrderItem>;
};

/** Autogenerated input type of DeletePaymentMethodMutation */
export type DeletePaymentMethodMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeletePaymentMethodMutation. */
export type DeletePaymentMethodMutationPayload = {
  __typename?: 'DeletePaymentMethodMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of DeleteUserMutation */
export type DeleteUserMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeleteUserMutation. */
export type DeleteUserMutationPayload = {
  __typename?: 'DeleteUserMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  success: Scalars['Boolean']['output'];
};

export type Delivery = {
  __typename?: 'Delivery';
  cartwheelJobId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  driverName?: Maybe<Scalars['String']['output']>;
  driverPhone?: Maybe<Scalars['String']['output']>;
  dropoffEtaAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  order: Order;
  photoUrls?: Maybe<Array<Scalars['String']['output']>>;
  pickupEtaAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: DeliveryStatus;
  trackingUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type DeliveryAddress = {
  __typename?: 'DeliveryAddress';
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  deliveryQuote?: Maybe<DeliveryQuote>;
  discardedAt: Scalars['ISO8601DateTime']['output'];
  formattedAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['ID']['output'];
  location?: Maybe<Location>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
  zip?: Maybe<Scalars['String']['output']>;
};


export type DeliveryAddressDeliveryQuoteArgs = {
  menuId: Scalars['ID']['input'];
};

export type DeliveryAddressAttributes = {
  city?: InputMaybe<Scalars['String']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  discard?: InputMaybe<Scalars['Boolean']['input']>;
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['ID']['input']>;
  locationAttributes?: InputMaybe<LocationAttributes>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type DeliveryQuote = {
  __typename?: 'DeliveryQuote';
  available: Scalars['Boolean']['output'];
  /** Duration in minutes */
  duration?: Maybe<Scalars['Int']['output']>;
  estimatedDropoffAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  estimatedPickupAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  fee?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  unavailableReason?: Maybe<Scalars['String']['output']>;
};

export enum DeliveryStatus {
  /** accepted */
  Accepted = 'ACCEPTED',
  /** at_pickup */
  AtPickup = 'AT_PICKUP',
  /** done_cancelled, cancelled */
  Canceled = 'CANCELED',
  /** done_delivered, completed */
  Delivered = 'DELIVERED',
  /** done_cannot_deliver */
  DeliveryProblem = 'DELIVERY_PROBLEM',
  /** picked_up, transit_to_dropoff, at_dropoff */
  DropoffEnroute = 'DROPOFF_ENROUTE',
  /** transit_to_pickup, food_not_ready */
  PickupEnroute = 'PICKUP_ENROUTE',
  /** return_in_progress, returned */
  Returned = 'RETURNED',
  /** submitted and waiting for driver */
  Submitted = 'SUBMITTED',
  /** another status */
  Unknown = 'UNKNOWN'
}

export type Device = {
  __typename?: 'Device';
  appVersion?: Maybe<Scalars['String']['output']>;
  clientUuid: Scalars['String']['output'];
  deviceName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isOnline: Scalars['Boolean']['output'];
  lastSeenAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  osInfo?: Maybe<Scalars['String']['output']>;
  restaurantId: Scalars['ID']['output'];
  settings: Scalars['JSON']['output'];
  settingsUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updateId?: Maybe<Scalars['String']['output']>;
};

/** Represents direct upload credentials */
export type DirectUpload = {
  __typename?: 'DirectUpload';
  /** Created blob record ID */
  blobId: Scalars['ID']['output'];
  /** HTTP request headers (JSON-encoded) */
  headers: Scalars['String']['output'];
  /** Created blob record signed ID */
  signedBlobId: Scalars['ID']['output'];
  /** Upload URL */
  url: Scalars['String']['output'];
};

/** File information required to prepare a direct upload */
export type DirectUploadInputObject = {
  /** File size (bytes) */
  byteSize: Scalars['Int']['input'];
  /** MD5 file checksum as base64 */
  checksum: Scalars['String']['input'];
  /** File content type */
  contentType: Scalars['String']['input'];
  /** Original file name */
  filename: Scalars['String']['input'];
};

export type Discount = {
  __typename?: 'Discount';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  kind: DiscountKind;
  name: Scalars['String']['output'];
  position: Scalars['Float']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  value?: Maybe<Scalars['Int']['output']>;
  valueType: DiscountValue;
};

export enum DiscountKind {
  /** item */
  Item = 'ITEM',
  /** order */
  Order = 'ORDER'
}

export enum DiscountValue {
  /** discount percent - basis points */
  BasisPoints = 'BASIS_POINTS',
  /** discount amount - cents */
  Cents = 'CENTS'
}

/** Autogenerated input type of E2eResetMutation */
export type E2eResetMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of E2eResetMutation. */
export type E2eResetMutationPayload = {
  __typename?: 'E2eResetMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  restaurant?: Maybe<Restaurant>;
  user?: Maybe<User>;
  userCode?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of EditOrderItemMutation */
export type EditOrderItemMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  instructions?: InputMaybe<Scalars['String']['input']>;
  modifierIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of EditOrderItemMutation. */
export type EditOrderItemMutationPayload = {
  __typename?: 'EditOrderItemMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  orderItem?: Maybe<OrderItem>;
};

/** Autogenerated input type of EditOrderMutation */
export type EditOrderMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set to true to charge this Order - requires table and paymentMethodId to be set on this Order */
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryAddressAttributes?: InputMaybe<DeliveryAddressAttributes>;
  discountCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fulfillment?: InputMaybe<Fulfillment>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  packaging?: InputMaybe<Packaging>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  scheduledAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  serviceFee?: InputMaybe<Scalars['Int']['input']>;
  serviceFeePercent?: InputMaybe<Scalars['Int']['input']>;
  table?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of EditOrderMutation. */
export type EditOrderMutationPayload = {
  __typename?: 'EditOrderMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  order?: Maybe<Order>;
};

export type Employment = {
  __typename?: 'Employment';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  discarded: Scalars['Boolean']['output'];
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  hasActiveShift: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  orders?: Maybe<Array<Order>>;
  permissions?: Maybe<Array<Permission>>;
  restaurant: Restaurant;
  shifts?: Maybe<Array<Shift>>;
  tickets?: Maybe<Array<Ticket>>;
  tippable: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};


export type EmploymentShiftsArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Autogenerated input type of EnrollLoyaltyMutation */
export type EnrollLoyaltyMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['ID']['input'];
};

/** Autogenerated return type of EnrollLoyaltyMutation. */
export type EnrollLoyaltyMutationPayload = {
  __typename?: 'EnrollLoyaltyMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  loyaltyAccount?: Maybe<LoyaltyAccount>;
};

/** Error Type */
export type Error = {
  __typename?: 'Error';
  /** Error message */
  message: Scalars['String']['output'];
  /** Error path */
  path?: Maybe<Array<Scalars['String']['output']>>;
  /** Error type */
  type?: Maybe<Scalars['String']['output']>;
};

export type FeeSchedule = {
  __typename?: 'FeeSchedule';
  giftCardPurchase: Scalars['Boolean']['output'];
  payableType: Scalars['String']['output'];
  paymentType: OrderPayment;
  processingFeeJsFunc: Scalars['String']['output'];
  restaurant: Restaurant;
};

export enum Fulfillment {
  /** On demand delivery */
  Delivery = 'DELIVERY',
  /** Pickup in person */
  Pickup = 'PICKUP'
}

export type GiftCard = {
  __typename?: 'GiftCard';
  balance: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  initialValue: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  isInternal: Scalars['Boolean']['output'];
  lastTransactionAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  order?: Maybe<Order>;
  payments: Array<Payment>;
  restaurantGroup: RestaurantGroup;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};

export type GiftCardTransaction = {
  __typename?: 'GiftCardTransaction';
  amount?: Maybe<Scalars['Int']['output']>;
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  giftCard: GiftCard;
  id: Scalars['ID']['output'];
  order: Order;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Invoice = {
  __typename?: 'Invoice';
  /** Outstanding deposit if one is unpaid, otherwise the full remaining balance */
  amountDueNow: Scalars['Int']['output'];
  balanceDue: Scalars['Int']['output'];
  canDiscard: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Deposit in cents; derived from depositPercent when that is set */
  depositAmount?: Maybe<Scalars['Int']['output']>;
  depositPaid: Scalars['Boolean']['output'];
  depositPercent?: Maybe<Scalars['Float']['output']>;
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Date the remaining balance is due */
  eventDate?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  invoiceItems: Array<InvoiceItem>;
  name?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** subtotal + unincludedTax */
  payableTotal: Scalars['Int']['output'];
  paymentStatus: OrderPaymentStatus;
  payments: Array<Payment>;
  processingFee: Scalars['Int']['output'];
  restaurant?: Maybe<Restaurant>;
  stage: InvoiceStage;
  subtotal: Scalars['Int']['output'];
  tax: Scalars['Int']['output'];
  taxExempt: Scalars['Boolean']['output'];
  taxExemptNote?: Maybe<Scalars['String']['output']>;
  tip?: Maybe<Scalars['Int']['output']>;
  tippable: Scalars['Boolean']['output'];
  total: Scalars['Int']['output'];
  unincludedTax: Scalars['Int']['output'];
  unpaidBalance: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};

export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  invoice: Invoice;
  key: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  price: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  taxIncluded: Scalars['Boolean']['output'];
  unitPrice: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum InvoiceStage {
  /** Deposit covered; the remaining balance is outstanding */
  BalanceDue = 'BALANCE_DUE',
  /** Deposit configured and not yet covered */
  DepositDue = 'DEPOSIT_DUE',
  /** No deposit configured; the full balance is payable */
  NoDeposit = 'NO_DEPOSIT',
  /** Balance outstanding past the event date */
  Overdue = 'OVERDUE',
  /** Fully paid */
  Paid = 'PAID'
}

export type Item = {
  __typename?: 'Item';
  color?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  decoratedName?: Maybe<Scalars['String']['output']>;
  decoratedShortName?: Maybe<Scalars['String']['output']>;
  decoration?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  effectiveTaxRate: TaxRate;
  hiddenOnline: Scalars['Boolean']['output'];
  hiddenPos: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Item Group */
  itemGroup: ItemGroup;
  /** @deprecated Use color instead */
  kdsColor?: Maybe<Scalars['String']['output']>;
  /** Modifier Group */
  modifierGroups?: Maybe<Array<ModifierGroup>>;
  name?: Maybe<Scalars['String']['output']>;
  outOfStock: Scalars['Boolean']['output'];
  position: Scalars['Float']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  stationIds: Array<Scalars['ID']['output']>;
  stations: Array<Station>;
  submenus: Array<Submenu>;
  taxIncluded: Scalars['Boolean']['output'];
  taxRate?: Maybe<TaxRate>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type ItemModifierGroupsArgs = {
  hiddenOnline?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemGroup = {
  __typename?: 'ItemGroup';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  decoratedName?: Maybe<Scalars['String']['output']>;
  decoratedShortName?: Maybe<Scalars['String']['output']>;
  decoration?: Maybe<Scalars['String']['output']>;
  defaultTaxRate?: Maybe<TaxRate>;
  description?: Maybe<Scalars['String']['output']>;
  hiddenOnline: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Items */
  items: Array<Item>;
  menu: Menu;
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Float']['output'];
  scheduleEnabled: Scalars['Boolean']['output'];
  schedules: Array<Schedule>;
  shortName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type ItemGroupItemsArgs = {
  hiddenOnline?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemRefund = {
  __typename?: 'ItemRefund';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  orderItem: OrderItem;
  quantity?: Maybe<Scalars['Int']['output']>;
  refund: Refund;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Like = {
  __typename?: 'Like';
  createdAt: Scalars['ISO8601DateTime']['output'];
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  order: Order;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};

export type Location = {
  __typename?: 'Location';
  /** Latitude */
  lat: Scalars['Float']['output'];
  /** Longitude */
  lon: Scalars['Float']['output'];
};

export type LocationAttributes = {
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
};

export type LoyaltyAccount = {
  __typename?: 'LoyaltyAccount';
  /** Raw item-based punch arithmetic (floor(punch_balance / earning_threshold)); NOT surface-aware. Prefer `rewardsAvailable(surface:)` for redemption gating. Null for dollar-based programs. */
  availableRewards?: Maybe<Scalars['Int']['output']>;
  /** Whether the current viewer is permitted to call adjustLoyaltyAccount on this account (owner/admin of any restaurant in the account's group). */
  canAdjust: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  lifetimePoints: Scalars['Int']['output'];
  /** Representative program for progress/rewards — the querying restaurant's program if context[:loyalty_program_restaurant] is set, else the oldest active program in the group. Raises when the group has no programs. */
  loyaltyProgram: LoyaltyProgram;
  /** Authentication: Auth Token only. */
  loyaltyTransactions: Array<LoyaltyTransaction>;
  pointsBalance: Scalars['Int']['output'];
  /** Points still needed for a redeemable reward on the querying surface. Returns 0 when no reward is redeemable on that surface (mirrors `rewardsAvailable` so the badge and progress can't disagree). Same surface semantics as `rewardsAvailable`. */
  pointsToNextReward: Scalars['Int']['output'];
  /** Points toward next reward */
  progress: Scalars['Int']['output'];
  punchBalance: Scalars['Int']['output'];
  /** Restaurant that owns the representative program. */
  restaurant: Restaurant;
  restaurantGroup: RestaurantGroup;
  /** Redemption count for the querying surface. Pass POS from cashier/kiosk, ONLINE from storefront. */
  rewardsAvailable: Scalars['Int']['output'];
  smsOptedOut: Scalars['Boolean']['output'];
  totalRedemptions: Scalars['Int']['output'];
  /**
   * Paginated transaction history, most recent first.
   *
   * Authentication: Auth Token only.
   */
  transactions: LoyaltyTransactionConnection;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};


export type LoyaltyAccountPointsToNextRewardArgs = {
  surface?: InputMaybe<RedemptionSurface>;
};


export type LoyaltyAccountRewardsAvailableArgs = {
  surface?: InputMaybe<RedemptionSurface>;
};


export type LoyaltyAccountTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LoyaltyDailyStat = {
  __typename?: 'LoyaltyDailyStat';
  date: Scalars['ISO8601Date']['output'];
  enrollments: Scalars['Int']['output'];
  pointsEarned: Scalars['Int']['output'];
  punchesEarned: Scalars['Int']['output'];
  rewardsRedeemed: Scalars['Int']['output'];
};

export enum LoyaltyEnrollmentPlacement {
  /** Show enrollment screen after payment */
  PostPayment = 'POST_PAYMENT',
  /** Show enrollment screen before tip selection */
  PreTip = 'PRE_TIP'
}

export type LoyaltyProgram = {
  __typename?: 'LoyaltyProgram';
  active: Scalars['Boolean']['output'];
  /** Members with at least one order in date range */
  activeMembersCount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  dailyStats: Array<LoyaltyDailyStat>;
  displayName?: Maybe<Scalars['String']['output']>;
  earningItemGroupIds: Array<Scalars['ID']['output']>;
  earningThreshold?: Maybe<Scalars['Int']['output']>;
  earningType: Scalars['String']['output'];
  /** Total enrolled loyalty accounts */
  enrolledCount: Scalars['Int']['output'];
  enrollmentDescription?: Maybe<Scalars['String']['output']>;
  enrollmentHeading?: Maybe<Scalars['String']['output']>;
  enrollmentScreenPlacement: LoyaltyEnrollmentPlacement;
  id: Scalars['ID']['output'];
  /** Fraction of identified customers who are loyalty members (0.0-1.0) */
  loyaltyPenetration: Scalars['Float']['output'];
  pointsPerDollar?: Maybe<Scalars['Int']['output']>;
  progressMessage?: Maybe<Scalars['String']['output']>;
  restaurant: Restaurant;
  /** Avg spend comparison between members and non-members */
  revenueComparison: LoyaltyRevenueComparison;
  /** Total cost of comped items in cents */
  rewardCost: Scalars['Int']['output'];
  rewardEarnedMessage?: Maybe<Scalars['String']['output']>;
  rewardIncludesModifiers: Scalars['Boolean']['output'];
  rewardItemGroupIds: Array<Scalars['ID']['output']>;
  smsProgressEnabled: Scalars['Boolean']['output'];
  starterPoints: Scalars['Int']['output'];
  /** Top users by redemption count in a date range */
  topRedeemers: Array<LoyaltyTopRedeemer>;
  /** Sum of lifetime points across all accounts */
  totalPointsEarned: Scalars['Int']['output'];
  /** Total punches earned (item-based programs) */
  totalPunchesEarned: Scalars['Int']['output'];
  /** Total rewards redeemed across all accounts */
  totalRewardsRedeemed: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  welcomeMessage?: Maybe<Scalars['String']['output']>;
};


export type LoyaltyProgramActiveMembersCountArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type LoyaltyProgramDailyStatsArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type LoyaltyProgramLoyaltyPenetrationArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type LoyaltyProgramRevenueComparisonArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type LoyaltyProgramRewardCostArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type LoyaltyProgramTopRedeemersArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['ISO8601Date']['input'];
};

export type LoyaltyRevenueComparison = {
  __typename?: 'LoyaltyRevenueComparison';
  /** Average gross order subtotal (cents) for post-enrollment member orders */
  memberAvgSpend: Scalars['Int']['output'];
  /** Count of post-enrollment member orders in the range */
  memberOrderCount: Scalars['Int']['output'];
  /** Fraction of identified members with 2+ post-enrollment orders (0.0-1.0) */
  memberRepeatRate: Scalars['Float']['output'];
  /** Net revenue (cents) from post-enrollment member orders */
  memberTotalRevenue: Scalars['Int']['output'];
  /** Average order subtotal (cents) for non-member orders (includes guests) */
  nonMemberAvgSpend: Scalars['Int']['output'];
  /** Count of non-member orders in the range (includes guests) */
  nonMemberOrderCount: Scalars['Int']['output'];
  /** Fraction of identified non-members with 2+ orders (0.0-1.0) */
  nonMemberRepeatRate: Scalars['Float']['output'];
};

export type LoyaltyTopRedeemer = {
  __typename?: 'LoyaltyTopRedeemer';
  /** Redemption count in the date range */
  redemptions: Scalars['Int']['output'];
  /** Gross spend (cents) in the date range, including comped items */
  totalSpend?: Maybe<Scalars['Int']['output']>;
  userName: Scalars['String']['output'];
  userPhone?: Maybe<Scalars['String']['output']>;
  /** Number of non-canceled orders in the date range */
  visitCount?: Maybe<Scalars['Int']['output']>;
};

export type LoyaltyTransaction = {
  __typename?: 'LoyaltyTransaction';
  /** Operator who initiated the transaction (populated for manual_adjustment rows). */
  actor?: Maybe<User>;
  balanceAfter: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  order?: Maybe<Order>;
  points: Scalars['Int']['output'];
  /** Balance immediately before this transaction. Nullable for pre-feature historical rows. */
  previousBalance?: Maybe<Scalars['Int']['output']>;
  /** Operator-supplied reason (populated for manual_adjustment rows). */
  reason?: Maybe<Scalars['String']['output']>;
  /** Name of the comped order item for redeem and refund-reversal (adjustment) rows. Appends " +N more" when an order had multiple loyalty redemptions. */
  redeemedItemName?: Maybe<Scalars['String']['output']>;
  transactionType: LoyaltyTransactionTypeEnum;
};

/** The connection type for LoyaltyTransaction. */
export type LoyaltyTransactionConnection = {
  __typename?: 'LoyaltyTransactionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LoyaltyTransactionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LoyaltyTransaction>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LoyaltyTransactionEdge = {
  __typename?: 'LoyaltyTransactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LoyaltyTransaction>;
};

export enum LoyaltyTransactionTypeEnum {
  /** System adjustment (e.g. refund reversal) */
  Adjustment = 'ADJUSTMENT',
  /** Points earned from a purchase */
  Earn = 'EARN',
  /** Operator-initiated manual adjustment */
  ManualAdjustment = 'MANUAL_ADJUSTMENT',
  /** Points redeemed for a reward */
  Redeem = 'REDEEM',
  /** Starter points granted on enrollment */
  Starter = 'STARTER'
}

export type Menu = {
  __typename?: 'Menu';
  createdAt: Scalars['ISO8601DateTime']['output'];
  default: Scalars['Boolean']['output'];
  /** Cartwheel Team ID */
  deliveryTeamId?: Maybe<Scalars['ID']['output']>;
  enableScheduledOrders: Scalars['Boolean']['output'];
  /** Special item used to create gift card order */
  giftCardItem: Item;
  id: Scalars['ID']['output'];
  /** Item Groups */
  itemGroups: Array<ItemGroup>;
  /** Minimum gross subtotal for an order */
  minGrossSubtotal: Scalars['Int']['output'];
  /** Minimum lead time for an order */
  minLeadMinutes: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Restaurant */
  restaurant: Restaurant;
  /** Maximum number of scheduled orders per slot; null means unlimited capacity */
  scheduledSlotCapacity?: Maybe<Scalars['Int']['output']>;
  /** Length of a scheduled slot in minutes */
  scheduledSlotLength: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type MenuItemGroupsArgs = {
  hiddenOnline?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Modifier = {
  __typename?: 'Modifier';
  createdAt: Scalars['ISO8601DateTime']['output'];
  decoratedName?: Maybe<Scalars['String']['output']>;
  decoratedShortName?: Maybe<Scalars['String']['output']>;
  decoration?: Maybe<Scalars['String']['output']>;
  hiddenOnline: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Modifier Group */
  modifierGroup: ModifierGroup;
  name?: Maybe<Scalars['String']['output']>;
  outOfStock: Scalars['Boolean']['output'];
  position: Scalars['Float']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ModifierGroup = {
  __typename?: 'ModifierGroup';
  createdAt: Scalars['ISO8601DateTime']['output'];
  decoratedName?: Maybe<Scalars['String']['output']>;
  decoratedShortName?: Maybe<Scalars['String']['output']>;
  decoration?: Maybe<Scalars['String']['output']>;
  defaultModifier?: Maybe<Modifier>;
  hiddenOnline: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isVariant: Scalars['Boolean']['output'];
  item: Item;
  maxSelect?: Maybe<Scalars['Int']['output']>;
  minSelect?: Maybe<Scalars['Int']['output']>;
  modifiers: Array<Modifier>;
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Float']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type ModifierGroupModifiersArgs = {
  hiddenOnline?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addOrderItem?: Maybe<AddOrderItemMutationPayload>;
  applyLoyaltyReward?: Maybe<ApplyLoyaltyRewardMutationPayload>;
  createAvatarUpload?: Maybe<CreateAvatarUploadMutationPayload>;
  createLoyaltyProgram?: Maybe<CreateLoyaltyProgramMutationPayload>;
  createOrder?: Maybe<CreateOrderMutationPayload>;
  createPayment?: Maybe<CreatePaymentMutationPayload>;
  createSetupIntent?: Maybe<CreateSetupIntentMutationPayload>;
  deleteOrderItem?: Maybe<DeleteOrderItemMutationPayload>;
  deletePaymentMethod?: Maybe<DeletePaymentMethodMutationPayload>;
  deleteUser?: Maybe<DeleteUserMutationPayload>;
  e2eReset?: Maybe<E2eResetMutationPayload>;
  editOrder?: Maybe<EditOrderMutationPayload>;
  editOrderItem?: Maybe<EditOrderItemMutationPayload>;
  enrollLoyalty?: Maybe<EnrollLoyaltyMutationPayload>;
  sendOrderEmail?: Maybe<SendOrderEmailMutationPayload>;
  setDefaultPaymentMethod?: Maybe<SetDefaultPaymentMethodMutationPayload>;
  setLike?: Maybe<SetLikeMutationPayload>;
  submitRestaurantContactRequest?: Maybe<SubmitRestaurantContactRequestMutationPayload>;
  unapplyLoyaltyReward?: Maybe<UnapplyLoyaltyRewardMutationPayload>;
  updateLoyaltyProgram?: Maybe<UpdateLoyaltyProgramMutationPayload>;
  updateUser?: Maybe<UpdateUserMutationPayload>;
};


export type MutationAddOrderItemArgs = {
  input: AddOrderItemMutationInput;
};


export type MutationApplyLoyaltyRewardArgs = {
  input: ApplyLoyaltyRewardMutationInput;
};


export type MutationCreateAvatarUploadArgs = {
  input: CreateAvatarUploadMutationInput;
};


export type MutationCreateLoyaltyProgramArgs = {
  input: CreateLoyaltyProgramMutationInput;
};


export type MutationCreateOrderArgs = {
  input: CreateOrderMutationInput;
};


export type MutationCreatePaymentArgs = {
  input: CreatePaymentMutationInput;
};


export type MutationCreateSetupIntentArgs = {
  input: CreateSetupIntentMutationInput;
};


export type MutationDeleteOrderItemArgs = {
  input: DeleteOrderItemMutationInput;
};


export type MutationDeletePaymentMethodArgs = {
  input: DeletePaymentMethodMutationInput;
};


export type MutationDeleteUserArgs = {
  input: DeleteUserMutationInput;
};


export type MutationE2eResetArgs = {
  input: E2eResetMutationInput;
};


export type MutationEditOrderArgs = {
  input: EditOrderMutationInput;
};


export type MutationEditOrderItemArgs = {
  input: EditOrderItemMutationInput;
};


export type MutationEnrollLoyaltyArgs = {
  input: EnrollLoyaltyMutationInput;
};


export type MutationSendOrderEmailArgs = {
  input: SendOrderEmailMutationInput;
};


export type MutationSetDefaultPaymentMethodArgs = {
  input: SetDefaultPaymentMethodMutationInput;
};


export type MutationSetLikeArgs = {
  input: SetLikeMutationInput;
};


export type MutationSubmitRestaurantContactRequestArgs = {
  input: SubmitRestaurantContactRequestMutationInput;
};


export type MutationUnapplyLoyaltyRewardArgs = {
  input: UnapplyLoyaltyRewardMutationInput;
};


export type MutationUpdateLoyaltyProgramArgs = {
  input: UpdateLoyaltyProgramMutationInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserMutationInput;
};

export type OpeningHours = {
  __typename?: 'OpeningHours';
  closed: Scalars['Boolean']['output'];
  day: Scalars['Int']['output'];
  openingPeriods: Array<OpeningPeriod>;
};

export type OpeningHoursException = {
  __typename?: 'OpeningHoursException';
  closed: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  date: Scalars['ISO8601Date']['output'];
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  openingPeriods: Array<OpeningPeriod>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type OpeningPeriod = {
  __typename?: 'OpeningPeriod';
  endTime: Scalars['Int']['output'];
  startTime: Scalars['Int']['output'];
};

export type Order = {
  __typename?: 'Order';
  /** Total after gift cards */
  amountCharged: Scalars['Int']['output'];
  bonus?: Maybe<Bonus>;
  cancelReason?: Maybe<CancelReason>;
  cancelableStatus: CancelableStatus;
  cashCollected?: Maybe<Scalars['Int']['output']>;
  cashReturned?: Maybe<Scalars['Int']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  delivery?: Maybe<Delivery>;
  deliveryAddress?: Maybe<DeliveryAddress>;
  deliveryFee: Scalars['Int']['output'];
  /** Portion of the tip that goes to the delivery provider */
  deliveryTip: Scalars['Int']['output'];
  discount?: Maybe<Discount>;
  /** Order level discounts */
  discountAmount: Scalars['Int']['output'];
  discountValue?: Maybe<Scalars['Int']['output']>;
  employees: Array<User>;
  estimatedDeliveryAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  expectedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  fulfillment: Fulfillment;
  giftCardTransaction?: Maybe<GiftCardTransaction>;
  /** Subtotal before discounts */
  grossSubtotal: Scalars['Int']['output'];
  hasBonus: Scalars['Boolean']['output'];
  hasDelivery: Scalars['Boolean']['output'];
  hasLoyaltyTransactions: Scalars['Boolean']['output'];
  hasRefund: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated tax inclusion is no longer on a per order basis - only a per item basis */
  itemPriceIncludesTax: Scalars['Boolean']['output'];
  key?: Maybe<Scalars['ID']['output']>;
  largeParty: Scalars['Boolean']['output'];
  likers: Array<User>;
  likes: Array<Like>;
  loyaltyComps: Scalars['Int']['output'];
  loyaltyStatus?: Maybe<LoyaltyAccount>;
  loyaltyTransactions: Array<LoyaltyTransaction>;
  menu?: Maybe<Menu>;
  /** Subtotal after discounts before surcharge */
  netItemSubtotal: Scalars['Int']['output'];
  /** Amount this order contributes to net sales (excludes gift card sales) */
  netSales: Scalars['Int']['output'];
  /** Subtotal after discounts */
  netSubtotal: Scalars['Int']['output'];
  notifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  numItems: Scalars['Int']['output'];
  /** @deprecated Use code instead */
  number: Scalars['String']['output'];
  orderItems: Array<OrderItem>;
  orderSurcharges: Array<OrderSurcharge>;
  packaging?: Maybe<Packaging>;
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  payLater: Scalars['Boolean']['output'];
  /** subtotal + unincludedTax */
  payableTotal: Scalars['Int']['output'];
  paymentIntentId?: Maybe<Scalars['ID']['output']>;
  paymentLinkUrl: Scalars['String']['output'];
  paymentMethod?: Maybe<PaymentMethod>;
  paymentStatus: OrderPaymentStatus;
  paymentType?: Maybe<OrderPayment>;
  paymentUsers: Array<User>;
  payments: Array<Payment>;
  placedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  processingFee: Scalars['Int']['output'];
  purchasedGiftCard?: Maybe<GiftCard>;
  reaction?: Maybe<Reaction>;
  recalledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  refund?: Maybe<Refund>;
  refundableStatus: RefundableStatus;
  refundableTip: Scalars['Int']['output'];
  restaurant: Restaurant;
  scheduledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  sequence?: Maybe<Scalars['Int']['output']>;
  /** Portion of the tip that goes to the restaurant */
  serviceFee: Scalars['Int']['output'];
  serviceFeePercent?: Maybe<Scalars['Int']['output']>;
  shifts?: Maybe<Array<Shift>>;
  source: OrderSource;
  status: OrderStatus;
  streamOrder?: Maybe<StreamOrder>;
  stripeFee?: Maybe<Scalars['Int']['output']>;
  subtotal: Scalars['Int']['output'];
  /** tableMapping code */
  table?: Maybe<Scalars['String']['output']>;
  /** table name to display */
  tableDisplayName?: Maybe<Scalars['String']['output']>;
  /** tableMapping name */
  tableMapping?: Maybe<Scalars['String']['output']>;
  tax: Scalars['Int']['output'];
  taxExempt: Scalars['Boolean']['output'];
  taxExemptNote?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use unincludedTaxBasis instead */
  taxableAmount: Scalars['Float']['output'];
  ticketServers?: Maybe<Array<User>>;
  tickets?: Maybe<Array<Ticket>>;
  tip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  /** Order and item levels discounts */
  totalDiscountAmount: Scalars['Int']['output'];
  transferAmount?: Maybe<Scalars['Int']['output']>;
  unincludedTax: Scalars['Int']['output'];
  unincludedTaxBasis: Scalars['Float']['output'];
  unpaidBalance: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};


export type OrderLikesArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** The connection type for Order. */
export type OrderConnection = {
  __typename?: 'OrderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Order>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrderEdge = {
  __typename?: 'OrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Order>;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  canceled: Scalars['Boolean']['output'];
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  canceledQuantity: Scalars['Int']['output'];
  completed: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customItemGroup?: Maybe<ItemGroup>;
  discount?: Maybe<Discount>;
  discountAmount?: Maybe<Scalars['Int']['output']>;
  discountValue?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  instructionsPrice?: Maybe<Scalars['Int']['output']>;
  item: Item;
  itemRefund?: Maybe<ItemRefund>;
  key: Scalars['ID']['output'];
  loyaltyComped: Scalars['Boolean']['output'];
  loyaltyCompedModifiers: Scalars['Boolean']['output'];
  modifiers?: Maybe<Array<Modifier>>;
  name: Scalars['String']['output'];
  order: Order;
  preLoyaltyPrice: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  refundableItemTotal: Scalars['Int']['output'];
  taxIncluded: Scalars['Boolean']['output'];
  taxRate: TaxRate;
  undiscountedPrice: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Attributes for creating an order item */
export type OrderItemAttributes = {
  customItemGroupId?: InputMaybe<Scalars['ID']['input']>;
  discountId?: InputMaybe<Scalars['ID']['input']>;
  discountValue?: InputMaybe<Scalars['Int']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  instructionsPrice?: InputMaybe<Scalars['Int']['input']>;
  itemId: Scalars['ID']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  loyaltyComped?: InputMaybe<Scalars['Boolean']['input']>;
  modifierIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  quantity: Scalars['Int']['input'];
  taxIncluded?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OrderPayment {
  CardManualEntry = 'CARD_MANUAL_ENTRY',
  /** Credit Card */
  CardPresent = 'CARD_PRESENT',
  CardStored = 'CARD_STORED',
  /** Cash */
  Cash = 'CASH',
  /** Paid outside Avocado */
  External = 'EXTERNAL',
  /** Gift Card */
  GiftCard = 'GIFT_CARD',
  /** Legacy Online - no processing fee */
  LegacyOnline = 'LEGACY_ONLINE',
  NoPayment = 'NO_PAYMENT',
  /** Online */
  Online = 'ONLINE',
  Split = 'SPLIT',
  UsBankAccount = 'US_BANK_ACCOUNT'
}

export enum OrderPaymentStatus {
  /** Authorized */
  Authorized = 'AUTHORIZED',
  /** Canceled */
  Canceled = 'CANCELED',
  /** Paid */
  Paid = 'PAID',
  /** Pending */
  Pending = 'PENDING',
  /** Unpaid */
  Unpaid = 'UNPAID'
}

export enum OrderSource {
  /** Mobile */
  Mobile = 'MOBILE',
  /** POS */
  Pos = 'POS'
}

export enum OrderStatus {
  /** Visible on KDS */
  Accepted = 'ACCEPTED',
  /** Canceled */
  Canceled = 'CANCELED',
  /** Deprecated - Customer Charged */
  Charged = 'CHARGED',
  /** Deprecated - In process of getting charged */
  ChargePending = 'CHARGE_PENDING',
  /** Order prepared */
  Completed = 'COMPLETED',
  /** Shopping Cart Mode */
  Created = 'CREATED',
  /** Finalized by customer, but not visible on KDS */
  Placed = 'PLACED',
  /** Deprecated - Move from completed to accepted */
  Recalled = 'RECALLED',
  /** Open tab with tickets, not visible in KDS */
  TabOpened = 'TAB_OPENED'
}

export type OrderSurcharge = {
  __typename?: 'OrderSurcharge';
  amount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  order: Order;
  refundableTotal: Scalars['Int']['output'];
  surcharge: Surcharge;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum Packaging {
  /** Dine in */
  DineIn = 'DINE_IN',
  /** To go */
  ToGo = 'TO_GO'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Payment = {
  __typename?: 'Payment';
  /** Tip that is not part of the required largePartyTip */
  additionalTip?: Maybe<Scalars['Int']['output']>;
  /** Subtotal and tax */
  amount: Scalars['Int']['output'];
  cashCollected?: Maybe<Scalars['Int']['output']>;
  /** Signed amount added to this cash payment to reach the nearest nickel */
  cashRoundingAdjustment: Scalars['Int']['output'];
  clientSecret?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  delayedTip?: Maybe<Scalars['Int']['output']>;
  deliveryTip?: Maybe<Scalars['Int']['output']>;
  giftCard?: Maybe<GiftCard>;
  giftCardTransaction?: Maybe<GiftCardTransaction>;
  id: Scalars['ID']['output'];
  invoice: Invoice;
  key: Scalars['ID']['output'];
  largePartyTip?: Maybe<Scalars['Int']['output']>;
  merchantFee: Scalars['Int']['output'];
  order: Order;
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentOrderItems?: Maybe<Array<PaymentOrderItem>>;
  paymentType: OrderPayment;
  processingFee: Scalars['Int']['output'];
  serviceFee?: Maybe<Scalars['Int']['output']>;
  status: OrderPaymentStatus;
  stripeFee?: Maybe<Scalars['Int']['output']>;
  tip?: Maybe<Scalars['Int']['output']>;
  tipDelayed: Scalars['Boolean']['output'];
  total?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  brand?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  last4?: Maybe<Scalars['String']['output']>;
};

export type PaymentOrderItem = {
  __typename?: 'PaymentOrderItem';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  orderItem: OrderItem;
  payment: Payment;
  price: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum Permission {
  /** Can manage the associated stripe account */
  AccountManagement = 'ACCOUNT_MANAGEMENT',
  /** Can authenticate the POS / KDS */
  PosAuth = 'POS_AUTH',
  /** Receives notification on negative reactions */
  ReactionRecipient = 'REACTION_RECIPIENT',
  /** Can view reports */
  Reporting = 'REPORTING',
  /** System account which has full access */
  System = 'SYSTEM'
}

export type Query = {
  __typename?: 'Query';
  authType: Auth;
  deliveryQuote: DeliveryQuote;
  giftCard?: Maybe<GiftCard>;
  invoice: Invoice;
  item?: Maybe<Item>;
  loyaltyStatus?: Maybe<LoyaltyAccount>;
  me?: Maybe<User>;
  menu?: Maybe<Menu>;
  order: Order;
  orders: Array<Order>;
  ordersConnection: OrderConnection;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentMethods?: Maybe<Array<PaymentMethod>>;
  restaurant?: Maybe<Restaurant>;
  restaurantGroup?: Maybe<RestaurantGroup>;
  restaurants: Array<Restaurant>;
};


export type QueryAuthTypeArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDeliveryQuoteArgs = {
  deliveryAddressAttributes?: InputMaybe<DeliveryAddressAttributes>;
  menuId: Scalars['ID']['input'];
};


export type QueryGiftCardArgs = {
  code: Scalars['String']['input'];
};


export type QueryInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLoyaltyStatusArgs = {
  restaurantId: Scalars['ID']['input'];
};


export type QueryMenuArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrdersArgs = {
  restaurantId?: InputMaybe<Scalars['ID']['input']>;
  since?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  status?: InputMaybe<Array<OrderStatus>>;
};


export type QueryOrdersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  restaurantId?: InputMaybe<Scalars['ID']['input']>;
  since?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  status?: InputMaybe<Array<OrderStatus>>;
};


export type QueryPaymentMethodArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRestaurantArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRestaurantGroupArgs = {
  id: Scalars['ID']['input'];
};

export type Reaction = {
  __typename?: 'Reaction';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  isPositive?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  order: Order;
  reasons?: Maybe<Array<Reason>>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Reason = {
  __typename?: 'Reason';
  id: Scalars['ID']['output'];
  isPositive: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
};

export enum RedemptionSurface {
  /** Counts items a customer could actually order online right now. */
  Online = 'ONLINE',
  /** Counts items a cashier at the POS could actually sell right now. */
  Pos = 'POS'
}

export type Refund = {
  __typename?: 'Refund';
  /** Signed cash-rounding amount returned with a full refund; zero for partial refunds */
  cashRoundingAdjustment: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  order: Order;
  processingFee?: Maybe<Scalars['Int']['output']>;
  serviceFee?: Maybe<Scalars['Int']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  tip?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  transferAmount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum RefundableStatus {
  /** Delivery order */
  Delivery = 'DELIVERY',
  /** Refund window expired */
  Expired = 'EXPIRED',
  /** Free order */
  Free = 'FREE',
  /** Gift card purchase */
  GiftCardPurchased = 'GIFT_CARD_PURCHASED',
  /** Gift card used */
  GiftCardTransaction = 'GIFT_CARD_TRANSACTION',
  /** Can be refunded */
  Refundable = 'REFUNDABLE',
  /** Refunded */
  Refunded = 'REFUNDED',
  /** Used two or more payment methods */
  SplitPayment = 'SPLIT_PAYMENT',
  /** Unpaid */
  Unpaid = 'UNPAID'
}

export type Restaurant = {
  __typename?: 'Restaurant';
  address?: Maybe<Address>;
  bonusable: Scalars['Boolean']['output'];
  cardFeeCents: Scalars['Int']['output'];
  cardFeePercent: Scalars['Float']['output'];
  cashFeeCents: Scalars['Int']['output'];
  cashFeePercent: Scalars['Float']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentMenu: Menu;
  customItem: Item;
  /** Seconds after midnight when the day starts/ends */
  dayOffset: Scalars['Int']['output'];
  defaultPackaging: Packaging;
  defaultTaxRate: TaxRate;
  devices: Array<Device>;
  discounts: Array<Discount>;
  employments: Array<Employment>;
  /** @deprecated Use visible */
  enabled: Scalars['Boolean']['output'];
  /** @deprecated Use cardFeePercent */
  feePercent: Scalars['Float']['output'];
  feeSchedules: Array<FeeSchedule>;
  giftCardItem: Item;
  giftCards: Array<GiftCard>;
  hasActiveCashDrawers: Scalars['Boolean']['output'];
  hasActiveStreamLocationConnection: Scalars['Boolean']['output'];
  hasPickup: Scalars['Boolean']['output'];
  heroImageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoices: Array<Invoice>;
  kioskBackgroundImageUrl?: Maybe<Scalars['String']['output']>;
  largePartyDefaultTipPercent?: Maybe<Scalars['Float']['output']>;
  logoImageUrl?: Maybe<Scalars['String']['output']>;
  loyaltyProgram?: Maybe<LoyaltyProgram>;
  /** Menus */
  menus?: Maybe<Array<Menu>>;
  name?: Maybe<Scalars['String']['output']>;
  notifyOrderComplete: Scalars['Boolean']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  restaurantGroup: RestaurantGroup;
  salesTaxPercent: Scalars['Float']['output'];
  /** 1000x the salesTaxPercent */
  salesTaxRate: Scalars['Int']['output'];
  setting: RestaurantSetting;
  statementDescriptor: Scalars['String']['output'];
  statementDescriptorSuffix?: Maybe<Scalars['String']['output']>;
  stations: Array<Station>;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  /** Whether Stripe has approved this restaurant to accept card payments. Backed by a live Stripe::Account.retrieve call — only request when the caller specifically needs the boot-time onboarding-recovery signal. Returns null for viewers without the reporting/device-management gate and null on Stripe transport errors (distinguishable from a false). */
  stripeChargesEnabled?: Maybe<Scalars['Boolean']['output']>;
  submenus: Array<Submenu>;
  surcharges: Array<Surcharge>;
  tableMappings: Array<TableMapping>;
  tagline?: Maybe<Scalars['String']['output']>;
  taxRates: Array<TaxRate>;
  timeZone: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userRestaurantSettings: Array<UserRestaurantSetting>;
  visible: Scalars['Boolean']['output'];
  waitTime?: Maybe<Scalars['Int']['output']>;
};


export type RestaurantCurrentMenuArgs = {
  menuId?: InputMaybe<Scalars['ID']['input']>;
};


export type RestaurantDiscountsArgs = {
  kind?: InputMaybe<DiscountKind>;
};

export type RestaurantContactRequestFieldInput = {
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum RestaurantContactRequestKind {
  /** Restaurant catering request */
  Catering = 'CATERING',
  /** General restaurant contact request */
  Contact = 'CONTACT'
}

export type RestaurantGroup = {
  __typename?: 'RestaurantGroup';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Authentication: Auth Token only. */
  giftCards: Array<GiftCard>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  restaurants: Array<Restaurant>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  wordmarkUrl?: Maybe<Scalars['String']['output']>;
};

export type RestaurantSetting = {
  __typename?: 'RestaurantSetting';
  algolia: Algolia;
  assistantContext?: Maybe<Scalars['String']['output']>;
  /** When true, POS cash payments are rounded to the nearest nickel. */
  cashRoundingEnabled: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  enableDelivery: Scalars['Boolean']['output'];
  enableKiosk: Scalars['Boolean']['output'];
  enablePoem: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  itemPriceIncludesTax: Scalars['Boolean']['output'];
  largePartyDefaultTipPercent?: Maybe<Scalars['Int']['output']>;
  onlineAutoAccept: Scalars['Boolean']['output'];
  /** Seconds after midnight when the day starts/ends */
  openingHours?: Maybe<Array<OpeningHours>>;
  openingHoursExceptions: Array<OpeningHoursException>;
  /** Hours past midnight when payouts are sent out in to the restaurant's timezone */
  payoutHour: Scalars['Int']['output'];
  /** When true, each iPad has its own active cash drawer. When false (default), the restaurant has a single shared drawer. */
  perDeviceCashDrawers: Scalars['Boolean']['output'];
  pickupInstructions?: Maybe<Scalars['String']['output']>;
  restaurant: Restaurant;
  /** Sales tax rate in thousandths of a percent (e.g. 10.55% = 10550) */
  salesTaxRate: Scalars['Int']['output'];
  showEmployeeFinancials: Scalars['Boolean']['output'];
  signageConfig?: Maybe<Scalars['JSON']['output']>;
  /** Number of customers who clicked the external review link. */
  socialReviewClickCount: Scalars['Int']['output'];
  /** External review URL (Google, Yelp, etc.) shown after a positive reaction. https:// only. When present, customers who leave a positive reaction see a prompt linking to this URL; when blank, the feature is off. */
  socialReviewsUrl?: Maybe<Scalars['String']['output']>;
  storefront: StorefrontSetting;
  stripeTerminalLocation?: Maybe<Scalars['String']['output']>;
  tipAfterTax: Scalars['Boolean']['output'];
  tipAmounts?: Maybe<Array<Scalars['Int']['output']>>;
  tipPercentages: Array<Scalars['Int']['output']>;
  tipThreshold?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  waitTime?: Maybe<Scalars['Int']['output']>;
  withholdSalesTax: Scalars['Boolean']['output'];
};

export type Schedule = {
  __typename?: 'Schedule';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Day of the week - 1 is Monday, 7 is Sunday */
  day: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  /** End time in seconds from midnight */
  endTime: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  itemGroup: ItemGroup;
  /** Start time in seconds from midnight */
  startTime: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of SendOrderEmailMutation */
export type SendOrderEmailMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of SendOrderEmailMutation. */
export type SendOrderEmailMutationPayload = {
  __typename?: 'SendOrderEmailMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  order: Order;
};

/** Autogenerated input type of SetDefaultPaymentMethodMutation */
export type SetDefaultPaymentMethodMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of SetDefaultPaymentMethodMutation. */
export type SetDefaultPaymentMethodMutationPayload = {
  __typename?: 'SetDefaultPaymentMethodMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  previousId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of SetLikeMutation */
export type SetLikeMutationInput = {
  active: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetLikeMutation. */
export type SetLikeMutationPayload = {
  __typename?: 'SetLikeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  like?: Maybe<Like>;
};

export type Shift = {
  __typename?: 'Shift';
  bonusAmount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  employment: Employment;
  endAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  orders: Array<Order>;
  restaurant: Restaurant;
  startAt: Scalars['ISO8601DateTime']['output'];
  /** @deprecated Use orders */
  tippableOrders: Array<Order>;
  tips: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};

export type Station = {
  __typename?: 'Station';
  /** Assignable to a KDS */
  assignable: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  restaurantId: Restaurant;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type StorefrontSetting = {
  __typename?: 'StorefrontSetting';
  banner?: Maybe<Scalars['String']['output']>;
  defaultTipAmount?: Maybe<Scalars['Int']['output']>;
  defaultTipPercent?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Renamed to defaultTipPercent */
  defaultTipPercentage?: Maybe<Scalars['Int']['output']>;
  enableOnlineSpecialInstructions: Scalars['Boolean']['output'];
  tipAmounts?: Maybe<Array<Scalars['Int']['output']>>;
  tipPercentages: Array<Scalars['Int']['output']>;
  tipThreshold?: Maybe<Scalars['Int']['output']>;
};

export type StreamOrder = {
  __typename?: 'StreamOrder';
  brandLabel: Scalars['String']['output'];
  customerPhoneCode?: Maybe<Scalars['String']['output']>;
  deliveryDriverName?: Maybe<Scalars['String']['output']>;
  deliveryDriverPhone?: Maybe<Scalars['String']['output']>;
  deliveryDropoffEtaAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deliveryHandoffInstructions?: Maybe<Scalars['String']['output']>;
  deliveryPasscode?: Maybe<Scalars['String']['output']>;
  deliveryPickupEtaAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deliveryStatus?: Maybe<DeliveryStatus>;
  dspOrderNumber: Scalars['String']['output'];
  fulfillmentType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  sourceLabel: Scalars['String']['output'];
  streamStatus: Scalars['String']['output'];
};

export type Submenu = {
  __typename?: 'Submenu';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  restaurant: Restaurant;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of SubmitRestaurantContactRequestMutation */
export type SubmitRestaurantContactRequestMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  fields: Array<RestaurantContactRequestFieldInput>;
  kind: RestaurantContactRequestKind;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  recaptchaToken: Scalars['String']['input'];
  restaurantId: Scalars['ID']['input'];
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SubmitRestaurantContactRequestMutation. */
export type SubmitRestaurantContactRequestMutationPayload = {
  __typename?: 'SubmitRestaurantContactRequestMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  success: Scalars['Boolean']['output'];
};

export type Surcharge = {
  __typename?: 'Surcharge';
  automaticOnline: Scalars['Boolean']['output'];
  automaticQuickOrder: Scalars['Boolean']['output'];
  automaticTable: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nameWithValue: Scalars['String']['output'];
  position: Scalars['Float']['output'];
  restaurant: Restaurant;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  value: Scalars['Int']['output'];
};

export type TableMapping = {
  __typename?: 'TableMapping';
  code: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  kind: TableMappingKind;
  name: Scalars['String']['output'];
  restaurant?: Maybe<Restaurant>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum TableMappingKind {
  /** A dine-in table */
  DineIn = 'DINE_IN',
  /** A pickup location */
  PickupLocation = 'PICKUP_LOCATION'
}

export type TaxRate = {
  __typename?: 'TaxRate';
  createdAt: Scalars['ISO8601DateTime']['output'];
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  percent: Scalars['Float']['output'];
  rate: Scalars['Int']['output'];
};

export type Ticket = {
  __typename?: 'Ticket';
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  order: Order;
  orderItems: Array<OrderItem>;
  placedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  recalledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  sequence?: Maybe<Scalars['Int']['output']>;
  server?: Maybe<User>;
  status: OrderStatus;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of UnapplyLoyaltyRewardMutation */
export type UnapplyLoyaltyRewardMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderItemId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnapplyLoyaltyRewardMutation. */
export type UnapplyLoyaltyRewardMutationPayload = {
  __typename?: 'UnapplyLoyaltyRewardMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  orderItem?: Maybe<OrderItem>;
};

/** Autogenerated input type of UpdateLoyaltyProgramMutation */
export type UpdateLoyaltyProgramMutationInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  earningItemGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  earningThreshold?: InputMaybe<Scalars['Int']['input']>;
  earningType?: InputMaybe<Scalars['String']['input']>;
  enrollmentDescription?: InputMaybe<Scalars['String']['input']>;
  enrollmentHeading?: InputMaybe<Scalars['String']['input']>;
  enrollmentScreenPlacement?: InputMaybe<LoyaltyEnrollmentPlacement>;
  id: Scalars['ID']['input'];
  pointsPerDollar?: InputMaybe<Scalars['Int']['input']>;
  progressMessage?: InputMaybe<Scalars['String']['input']>;
  rewardEarnedMessage?: InputMaybe<Scalars['String']['input']>;
  rewardIncludesModifiers?: InputMaybe<Scalars['Boolean']['input']>;
  rewardItemGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  smsProgressEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  starterPoints?: InputMaybe<Scalars['Int']['input']>;
  welcomeMessage?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateLoyaltyProgramMutation. */
export type UpdateLoyaltyProgramMutationPayload = {
  __typename?: 'UpdateLoyaltyProgramMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  loyaltyProgram?: Maybe<LoyaltyProgram>;
};

/** Autogenerated input type of UpdateUserMutation */
export type UpdateUserMutationInput = {
  avatarBlobId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  defaultDeliveryAddressId?: InputMaybe<Scalars['ID']['input']>;
  deliveryAddressesAttributes?: InputMaybe<Array<DeliveryAddressAttributes>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasConfirmedName?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateUserMutation. */
export type UpdateUserMutationPayload = {
  __typename?: 'UpdateUserMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  user?: Maybe<User>;
};

export type User = {
  __typename?: 'User';
  /** Authentication: Auth Token only. */
  authType: Auth;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Authentication: Auth Token only. */
  defaultDeliveryAddress?: Maybe<DeliveryAddress>;
  /** Authentication: Auth Token only. */
  defaultDeliveryAddressId?: Maybe<Scalars['ID']['output']>;
  /** Authentication: Auth Token only. */
  defaultPaymentMethod?: Maybe<PaymentMethod>;
  /** Authentication: Auth Token only. */
  deliveryAddresses: Array<DeliveryAddress>;
  email?: Maybe<Scalars['String']['output']>;
  employers: Array<Restaurant>;
  employments: Array<Employment>;
  /** Authentication: Auth Token only. */
  firebaseId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hasConfirmedName: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isEmployed: Scalars['Boolean']['output'];
  /** Authentication: Auth Token only. */
  isSuperAdmin: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Authentication: Auth Token only. */
  payments: Array<Payment>;
  phone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userRestaurantSettings: Array<UserRestaurantSetting>;
};


export type UserEmployersArgs = {
  permission?: InputMaybe<Permission>;
};


export type UserEmploymentsArgs = {
  permission?: InputMaybe<Permission>;
};


export type UserUserRestaurantSettingsArgs = {
  restaurantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UserRestaurantSetting = {
  __typename?: 'UserRestaurantSetting';
  canMarket?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  restaurant: Restaurant;
  user: User;
};
